<template>
  <div class="content">商家个人中心

    <businessTabbar></businessTabbar>
  </div>
</template>

<script>
import businessTabbar from "@/components/businessTabbar";
export default {
  name: "userBusiness",
  data(){
    return {

    }
  },
  components: {
    businessTabbar
  }
}
</script>

<style scoped>

</style>
